import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-dummy',
  template: '',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DummyComponent {}
